import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';
import { CTA } from '../components/Layout/CTA';

import '../components/GlobalStyle.css';
import '../components/Backgrounds/Backgrounds.css';

import DatatoDrive from '../assets/images/Technology - Data to Drive.png';
import MessageValidation from '../assets/images/Technology - Message Validation.png';
import PowerfulDashboards from '../assets/images/Technology - Powerful Dashboards.png';
import ProgramSetup from '../assets/images/Technology - Program Setup Support.png';

import { FadeLoad, FadeScroll } from '../components/styled/Motion.styled';
import { ProductCards1, ProductCards2 } from '../components/TechnologyComponents/TechnologyCards';



const Technology = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Products & Services | Technology</title>
                <link rel="canonical" href="https://bestpayment.solutions/technology" />
            </Helmet>
            <Navigation />
            <Container fluid className='vh-75 circle-bg-4-scroll'>
                <Row className='pt-5 justify-content-evenly text-center'>
                    <Col lg={8}>
                        <FadeLoad>
                            <h2 className='fw-bold fs-24 color-sky-tint-1'>Technology</h2>
                            <h1 className='fs-60'>
                                Empowering your business with custom incentive technology solutions
                            </h1>
                        </FadeLoad>
                    </Col>
                    <Col lg={6} className='py-4'>
                        <FadeLoad>
                            <p className='py-4'>
                                At Best Payment Solutions, we combine our deep industry expertise with cutting-edge technology to create incentive programs that not only meet but exceed your goals. We offer everything from white-labeled sites to fully custom builds. Our technology solutions are crafted to be cost-effective, resonate with your brand, and empower your incentive program’s success.
                            </p>
                        </FadeLoad>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='vh-75 py-5'>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={4}>
                        <h3 className='fs-48'>
                            Innovative solutions for diverse incentive programs
                        </h3>
                        <p>
                            Our team delivers a broad range of incentive solutions, reflecting our commitment to quality and excellence. Whether you're looking to incentivize channel sales, boost employee engagement, or improve the effectiveness of your rebate programs, our technology is flexible and adaptable. Our range of incentive solutions include:
                        </p>
                    </Col>
                    <Col lg={7}>
                        <Row>
                            <FadeScroll>
                                <ProductCards1 />
                            </FadeScroll>
                        </Row>
                    </Col>
                </Row>
                <Row className="justify-content-evenly py-5">
                    <Col xs={12}>
                        <h5 className='fs-24 text-center pb-5'>We also offer solutions for</h5>
                    </Col>
                    <Col xs={12}>
                        <Row className='justify-content-center'>
                            <FadeScroll>
                                <ProductCards2 />
                            </FadeScroll>
                        </Row>
                    </Col>
                </Row>
            </Container >
            <Container fluid className='vh-50 bg-cream py-5'>
                <Row className='justify-content-center'>
                    <Col lg={10}>
                        <FadeScroll>
                            <h5 className='fs-24 text-center color-midnight'>
                                With Best Payment Solutions, you get more than just technology;
                                <br />
                                you get a partner committed to your success.
                            </h5>
                        </FadeScroll>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5'>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col xs={12}>
                        <h3 className='fs-48 text-center'>Technology features that set us apart</h3>
                    </Col>
                </Row>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={5} sm={10}>
                        <FadeScroll>
                            <img src={ProgramSetup} width='100%' />
                        </FadeScroll>
                    </Col>
                    <Col lg={5}>
                        <h5 className='pt-4 fs-24'>Quick program setup with lasting support</h5>
                        <p>
                            Our platforms can be fully operational in as little as 30 days, with an average turnaround time of less than 60 days. For more complex customizations, we deliver within 90 days. Even after launch, we focus on long-term success. We constantly refine and optimize our programs to ensure maximum client satisfaction.
                        </p>

                        <h5 className='pt-4 fs-24'>Proactive updates & improvements</h5>
                        <p>
                            Every program we manage is assigned a dedicated Customer Service lead. This proactive approach allows us to quickly identify and address any issues, ensuring continuous improvement and optimal performance. Our team is always on the lookout for ways to enhance the user experience and program effectiveness.
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={5} className='order-2 order-lg-1'>
                        <h5 className='pt-4 fs-24'>Powerful platform technology for participants & administrators</h5>
                        <p>
                            Our incentive program platforms are equipped with robust admin dashboards, offering comprehensive real-time program monitoring and the ability to quickly make or request changes.
                        </p>
                        <p>
                            For participants, our platforms offer a seamless and engaging experience. They can access program details, track their reward status, view their account information, and more, all within an intuitive user interface.
                        </p>
                        <p>
                            Both administrators and participants enjoy intuitive interfaces and easy access to essential information.
                        </p>
                    </Col>
                    <Col lg={5} sm={8} className='order-1 order-lg-2'>
                        <FadeScroll>
                            <img src={PowerfulDashboards} width='100%' />
                        </FadeScroll>
                    </Col>
                </Row>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={5} md={10}>
                        <FadeScroll>
                            <img src={MessageValidation} width='100%' />
                        </FadeScroll>
                    </Col>
                    <Col lg={5}>
                        <h5 className='pt-4 fs-24'>Targeted messaging for impactful program communications</h5>
                        <p>
                            Easily send targeted or program-wide messages directly from your admin dashboard. We have options for both opt-in text messaging and email to effectively keep participants informed and engaged.
                        </p>

                        <h5 className='pt-4 fs-24'>Advanced claims validation</h5>
                        <p>
                            Enjoy speed and accuracy in claim validation, keeping your programs running smoothly and efficiently. Our validation technology accelerates the reward process. This enhances participant satisfaction and improves your program’s success.
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={5} className='order-2 order-lg-1'>
                        <h5 className='pt-4 fs-24'>Data to drive decision making</h5>
                        <p>
                            Use program data to identify trends and set achievable goals. Our program dashboards come with ad hoc reporting capabilities. Easily filter and download vital program information and analytics data whenever you need it.
                        </p>

                        <h5 className='pt-4 fs-24'>Seamless integration & unmatched support</h5>
                        <p>
                            We ensure that our technology meets your needs and seamlessly integrates with your existing systems. Enjoy a smooth and successful implementation supported by our expert team. We provide comprehensive account management, customer service support, and program cost management.
                        </p>
                    </Col>
                    <Col lg={5} sm={8} className='order-1 order-lg-2'>
                        <FadeScroll>
                            <img src={DatatoDrive} width='100%' />
                        </FadeScroll>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5 bg-sky-tint-3'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default Technology;